<section
  global-hero
  class="family-history-hero"
  [heroData]="heroData"
></section>
<section
  jump-to
  [jumpToData]="jumpToData"
  [activeSection]="jumpToData[0].buttonFragment"
  [mobileWrap]="true"
  [reorderMobile]="false"
  [wrapIndex]="2"
></section>

<section class="family-history-intro bg-white">
  <div class="container">
    <div class="family-history-intro__content">
      <h2 class="family-history-intro__title text-start h1">
        The Family Factor: A T1D Risk Awareness Survey
      </h2>
      <p class="family-history-intro__text">
        New findings from a survey conducted by Beyond Type 1 and commissioned
        by Sanofi show a lack of disease awareness and persistent misconceptions
        around early risk detection exist among those with first degree family
        history of type 1 diabetes, despite being up to 15X more likely to
        develop the disease.
      </p>
      <p class="family-history-intro__text">
        With tens of thousands of Americans diagnosed with T1D every year, often
        in emergency situations, and many in the dark about their familial risk,
        it's time to ring the alarm bell on The Family Factor.
      </p>
    </div>
  </div>
</section>

<section id="lack-of-knowledge" class="pt-0 pt-lg-5 bg-white">
  <div survey-card [data]="lackOfKnowledgeData"></div>
</section>

<section id="kennedy-and-konas-story" class="family-history-video">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="family-history-video__container mx-auto">
          <h2>Watch Kennedy & Kona’s story </h2>
          <p class="mb-4">
            When Kennedy was diagnosed with type 1 diabetes, her
            family was blindsided. Now, they screen their son Cameron annually
            and are sharing their story to encourage more families to learn
            about their risk and talk with their doctor about screening. 
          </p>
          <div
            video-carousel
            [videoCarouselData]="videoData"
            [transcript]="true"
          ></div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="Misconceptions" class="bg-white pt-4">
  <div survey-card [data]="misconceptionsData"></div>
</section>

<section id="failure-to-act" class="bg-white pt-4">
  <div survey-card [data]="failureToActData"></div>
</section>

<section id="barriers-to-screening" class="bg-white pt-4">
  <div survey-card [data]="barriersToScreeningData"></div>
</section>

<section id="real-voices-experience" class="container-fluid bg-gray-100">
  <div class="row">
    <div class="col">
      <div class="real-voices mx-auto">
        <div class="mb-4">
          <h2>Real voices, real T1D experience.</h2>
          <p class="mb-5">
            Watch our collection of stories that drive home the importance of
            T1D awareness and screening, from both professional and patient
            perspectives.
          </p>
        </div>
        <div
          video-carousel
          [videoCarouselData]="videoData2"
          [transcript]="true"
        ></div>
      </div>
    </div>
  </div>
</section>

<section id="what-you-can-do" class="bg-white pt-4">
  <div survey-card [data]="whatYouCanDoData"></div>
</section>

<section class="family-history-cta mb-5">
  <div class="container">
    <div
      class="family-history-cta__box mx-auto d-flex flex-column align-items-center align-items-lg-start"
    >
      <div class="family-history-cta__text text-center text-lg-start">
        <h2 class="fw-extrabold text-gray-900 mb-0">
          If you want to know more, read the full 2026 Family Factor survey,
          including methodology, and click here to learn how to screen.
        </h2>
      </div>
      <div
        class="family-history-cta__buttons d-flex flex-row justify-content-center justify-content-lg-start gap-3 mt-4"
      >
        <div
          global-button
          [buttonData]="downloadSurveyButton"
          class="family-history-cta__btn family-history-cta__btn--orange w-fit"
        ></div>
        <div
          global-button
          [buttonData]="learnHowButton"
          class="family-history-cta__btn family-history-cta__btn--yellow w-fit"
        ></div>
      </div>
    </div>
  </div>
</section>

<section class="family-history-accordion bg-white pb-5">
  <div class="container">
    <div class="family-history-accordion__wrapper mx-auto" ngbAccordion>
      <div ngbAccordionItem [collapsed]="true">
        <h2 ngbAccordionHeader class="position-relative">
          <button ngbAccordionButton>
            <h3 class="mb-0 text-gray-900">About the Survey</h3>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <p class="mb-3">
                This survey was fielded by Ipsos (<a
                  href="https://www.ipsos.com"
                  target="_blank"
                  >www.ipsos.com</a
                >) as an online, 15-minute, self-administered survey among U.S.
                adults who are at risk of developing type 1 diabetes and
                caregivers to children under age 18 who are at risk of
                developing type 1 diabetes between April 1 and May 1, 2026. The
                national sample included 1,000 U.S. adults and caregivers who
                met survey qualification criteria. Additional augmented
                interviews were conducted in six key markets – TX, GA, CA, FL,
                MA, and NY – to achieve a base size of n=150 each, including a
                mix of at-risk adults and caregivers. Respondents were recruited
                from opt-in panels of general population respondents across the
                country.
              </p>
              <p class="mb-3">
                To participate as an at-risk adult, respondents had to be ages
                18-45 and have a first-degree family member (e.g., a parent,
                child, or sibling) diagnosed with T1D. To participate as a
                caregiver, respondents had to be ages 18-60 and be the parent or
                caregiver of a child who has a first-degree family member
                diagnosed with T1D. Potential respondents were excluded if they
                were unwilling to provide informed consent, were not the primary
                decision maker for their healthcare decisions or if they/their
                child had previously taken an autoantibody blood test for T1D.
                The final sample size for the survey is 1,511, including 511
                respondents for the state-level augments, which are not included
                in the national findings. No weights were applied to either
                sample, and findings reflect the opinions of these respondents
                only.
              </p>
              <p class="mb-0">The survey was commissioned by Sanofi.</p>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<review-bar [isUpdated]="true" [dateText]="'in August 2026'"></review-bar>
